import { datePickerValueToString } from '@civilgrid/ui/components';
import { capturePosthogEvent, POSTHOG_EVENTS } from '~/common/posthogEvents';
import type { PermittingProjectSource } from './permittingFormDefaults';
import type { PermittingFormValues } from './permittingFormTypes';

export type CapturePermitPdfGenerateRequestArgs = {
  routeProjectId: string;
  organizationId: string | undefined;
  userId: string | null;
  userEmail: string | null;
  project: PermittingProjectSource | null | undefined;
  form: PermittingFormValues;
};

/**
 * Fires when the user submits the permitting PDF form (“Generate request”).
 */
export function capturePermitPdfGenerateRequestSubmitted({
  routeProjectId,
  organizationId,
  userId,
  userEmail,
  project,
  form,
}: CapturePermitPdfGenerateRequestArgs): void {
  capturePosthogEvent(POSTHOG_EVENTS.permitPdfRequested, {
    projectId: routeProjectId,
    organizationId: organizationId ?? null,
    userId,
    userEmail,
    project: project
      ? {
          id: project.id,
          projectId: project.projectId,
          name: project.name,
          billingTier: project.billingTier,
          planStatus: project.planStatus,
          projectPhase: project.projectPhase,
          category: project.category,
          type: project.type,
          state: project.address2?.state?.trim() || null,
          geometry: project.geometry,
          geometryType: project.geometryType ?? null,
        }
      : null,
    form: {
      permitSubmissionDate: datePickerValueToString(form.permitSubmissionDate) || null,
      permitSubmissionContactName: form.permitSubmissionContactName.trim(),
      permitSubmissionContactEmail: form.permitSubmissionContactEmail.trim(),
      permitSubmissionContactPhone: form.permitSubmissionContactPhone.trim(),
      workStartDate: datePickerValueToString(form.workStartDate) || null,
      workEndDate: datePickerValueToString(form.workEndDate) || null,
      address: form.address.trim(),
      city: form.city.trim(),
      zip: form.zip.trim(),
      atmosRep: form.atmosRep.trim(),
      atmosEmail: form.atmosEmail.trim(),
      atmosPhone: form.atmosPhone.trim(),
      workTypeText: form.workTypeText.trim(),
      workTypeRadio: form.workTypeRadio,
      contractors: form.contractors.map((c) => ({
        type: c.type,
        name: c.name.trim(),
        repName: c.repName.trim(),
        email: c.email.trim(),
        phone: c.phone.trim(),
      })),
    },
  });
}
